module.exports = __webpack_public_path__ + "img/微信图片_20230327102138.de55979c.jpg";